import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';

const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page-container">
      <div className="container">
        <Link to="/" className="back-link">← Back to StudioIQ</Link>
        
        <div className="legal-header">
          <h1>Terms of Service</h1>
          <p>The Jeweler's Shop LLC dba StudioIQ</p>
        </div>

        <div className="effective-date">
          <strong>Effective Date:</strong> December 16, 2024
        </div>

        <div className="legal-content">
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing or using StudioIQ, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using StudioIQ.</p>

          <h2>2. Description of Service</h2>
          <p>StudioIQ is a web-based software platform that provides jewelry repair pricing calculations, quote generation, and work instruction tools for jewelry professionals. The service is provided by The Jeweler's Shop LLC dba StudioIQ.</p>

          <h2>3. User Accounts</h2>
          <h3>Account Creation</h3>
          <p>To use StudioIQ, you must create an account with accurate and complete information. You are responsible for maintaining the confidentiality of your account credentials.</p>

          <h3>Account Responsibilities</h3>
          <ul>
            <li>You must be 18 years or older or have parental consent</li>
            <li>You are responsible for all activities under your account</li>
            <li>You must notify us immediately of any unauthorized use</li>
            <li>One account per business entity unless otherwise arranged</li>
          </ul>

          <h2>4. Acceptable Use</h2>
          <p>You agree to use StudioIQ only for lawful purposes and in accordance with these Terms. You may not:</p>
          <ul>
            <li>Use the service for any illegal or unauthorized purpose</li>
            <li>Interfere with or disrupt the service or servers</li>
            <li>Attempt to gain unauthorized access to our systems</li>
            <li>Copy, modify, or distribute our software or content</li>
            <li>Use automated systems to access the service without permission</li>
            <li>Share your account credentials with unauthorized users</li>
          </ul>

          <h2>5. Subscription and Payment</h2>
          <h3>Subscription Plans</h3>
          <p>StudioIQ offers various subscription plans with different features and usage limits. Current pricing is available on our website.</p>

          <h3>Payment Terms</h3>
          <ul>
            <li>Subscriptions are billed monthly or annually in advance</li>
            <li>All fees are non-refundable except as required by law</li>
            <li>We may change pricing with 30 days notice</li>
            <li>Accounts may be suspended for non-payment</li>
          </ul>

          <h2>6. Intellectual Property</h2>
          <h3>Our Rights</h3>
          <p>StudioIQ, including all software, content, and pricing algorithms, is owned by The Jeweler's Shop LLC and protected by copyright and other intellectual property laws.</p>

          <h3>Your Rights</h3>
          <p>You retain ownership of the data you input into StudioIQ. You grant us a limited license to use your data to provide the service.</p>

          <h2>7. Privacy and Data</h2>
          <p>Your privacy is important to us. Please review our Privacy Policy to understand how we collect, use, and protect your information.</p>

          <h2>8. Service Availability</h2>
          <p>While we strive for high availability, we do not guarantee uninterrupted service. We may perform maintenance, updates, or experience outages that temporarily affect service availability.</p>

          <h2>9. Limitation of Liability</h2>
          <p>TO THE MAXIMUM EXTENT PERMITTED BY LAW, THE JEWELER'S SHOP LLC DBA STUDIOIQ SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO LOSS OF PROFITS, DATA, OR BUSINESS OPPORTUNITIES.</p>

          <h2>10. Disclaimers</h2>
          <p>StudioIQ is provided "as is" without warranties of any kind. While we strive for accuracy in our pricing calculations, you are responsible for verifying all quotes and pricing before presenting them to customers.</p>

          <h2>11. Termination</h2>
          <p>Either party may terminate this agreement at any time. Upon termination:</p>
          <ul>
            <li>Your access to StudioIQ will be suspended</li>
            <li>You may export your data within 30 days</li>
            <li>We may delete your account and data after 90 days</li>
            <li>All payment obligations remain in effect</li>
          </ul>

          <h2>12. Governing Law</h2>
          <p>These Terms are governed by the laws of the State of Florida, United States, without regard to conflict of law principles.</p>

          <h2>13. Changes to Terms</h2>
          <p>We reserve the right to modify these Terms at any time. Material changes will be communicated via email or through the StudioIQ application.</p>

          <div className="contact-info">
            <h4>Contact Us</h4>
            <p>If you have questions about these Terms of Service, please contact us:</p>
            <p><strong>The Jeweler's Shop LLC dba StudioIQ</strong><br/>
            Email: legal@studioiq.com<br/>
            Address: Florida, United States</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;